// import { Modal } from 'antd';
import request from 'src/utils/request';

//保险-接口
export const getInsurancePage = (params) =>
  request.get('/api/car/admin/grantAudit/insurance/page', { params });

export const undoInsurancePage = (id) =>
  request.post(`/api/car/admin/grantAudit/insurance/undo/${id}`);

export const deleteInsurancePage = (id) =>
  request.delete(`/api/car/admin/grantAudit/insurance/${id}`);

export const getInsuranceDetailsList = (id, params) =>
  request.get(`/api/car/admin/grantAudit/insurance/page/${id}`, { params });

export const getInsuranceDetails = (id) =>
  request.get(`/api/car/admin/grantAudit/insurance/detail/${id}`);

export const updateInsuranceReleaseTime = (data) =>
  request.post(`/api/car/admin/grantAudit/insurance/update`, data);

export const auditInsurance = (id, params) =>
  request.post(`/api/car/admin/grantAudit/insurance/audit/${id}`, params);

/**初审 */
export const firstAudit = (id, params) =>
  request.post(`/api/car/admin/grantAudit/insurance/audit/pre/${id}`, params);

/**复审 */
export const secondAudit = (id, params) =>
  request.post(`/api/car/admin/grantAudit/insurance/audit/sec/${id}`, params);

export const getAuditStatusList = (params) =>
  request.get('/api/car/admin/common/auditStatus', { params });

export const exportGrants = (params, responseType = 'blob') =>
  request.post('/api/car/admin/grantAudit/export/grant', params, { responseType });

export const getGrantTemplate = (activityId) =>
  request.get(`/api/car/admin/grantAudit/export/grantTemplate?activityId=${activityId}`, {
    responseType: 'blob',
  });

//导入
export const importGrantData = async (data, type) => {
  console.log(type, '=====type');
  if (type === 'AN_HUI') {
    return request.post('/api/ahzx/grant/import/grant', data, {
      params: { __INACTIVITY__: true },
    });
  }
  return request.post('/api/car/admin/grantAudit/import/grant', data, {
    params: { __INACTIVITY__: true },
  });
};

export const getPrizeTypeList = (params) =>
  request.get('/api/car/admin/common/prizeType', { params }).then((res) => {
    return res.content.map((item) => ({
      label: item.prizeTypeName,
      value: item.prizeTypeStatus,
      id: item.prizeTypeId,
    }));
  });

//经代接口
export const getAgencyPage = (params) =>
  request.get('/api/car/admin/grantAudit/agency/page', { params });

export const undoAgencyPage = (id) => request.post(`/api/car/admin/grantAudit/agency/undo/${id}`);

export const deleteAgency = (id) => request.delete(`/api/car/admin/grantAudit/undo/${id}`);

export const exportAgencyGrants = (params) =>
  request.post('/api/car/admin/grantAudit/export/agency/grant', params, { responseType: 'blob' });

export const getAgencyDetailsList = (id, params) =>
  request.get(`/api/car/admin/grantAudit/agency/page/${id}`, { params });

export const getAgencyDetails = (id) =>
  request.get(`/api/car/admin/grantAudit/agency/detail/${id}`);

export const auditAgency = (id, params) =>
  request.post(`/api/car/admin/grantAudit/agency/audit/${id}`, params);

export const getAgencyGrantTemplate = (type) =>
  request.get(`/api/car/admin/grantAudit/export/agency/grantTemplate?type=${type}`, {
    responseType: 'blob',
  });

export const importAgencyGrantData = (data) =>
  request.post('/api/car/admin/grantAudit/import/agency/grant', data);

//下载奖品发放数据模板带所属机构
export const getGrantTemplateOrg = (activityId) =>
  request.get(`/api/car/admin/grantAudit/export/grantTemplate/org?activityId=${activityId}`, {
    responseType: 'blob',
  });

//下载奖品发放数据模板带所属机构
export const importGrantDataOrg = async (data, type) => {
  return type === 'AN_HUI'
    ? request.post('/api/ahzx/grant/import/grant/org', data, { params: { __INACTIVITY__: true } })
    : request.post('/api/car/admin/grantAudit/import/grant/org', data, {
        params: { __INACTIVITY__: true },
      });
};

// 名单上传前先检查
export const importCheck = async (data) =>
  request.post('/api/car/admin/grantAudit/import/grant/check', data, {
    params: { __INACTIVITY__: true },
  });

export const downError = async (params) => {
  return request.get('/api/car/admin/grantAudit/import/error/down', {
    params,
    responseType: 'blob',
  });
};

//名单上传-立即生效
export const effectiveLot = (data) =>
  request.post('/api/car/admin/grantAudit/insurance/effective', data);

// 名单字段选项列表
export const getGrantAuditField = (id) =>
  request.get(`/api/car/admin/grantAudit/field/option/${id}`);
